"use client";

import { setCookie, getCookie, deleteCookie } from "cookies-next";
import { getLocaleFromUrl } from "./utils";

// import { Job } from "@/app";

// interface ApiOptions extends RequestInit {
//   headers?: Record<string, string>;
// }

// interface PaginatedResponse<T> {
//   data: T[];
//   meta: {
//     current_page: number;
//     last_page: number;
//     per_page: number;
//     total: number;
//   };
// }

// const get = async <T>(
//   endpoint: string,
//   options: ApiOptions = {}
// ): Promise<T> => {
//   const locale = getLocaleFromUrl();
//   const token = getCookie("token");

//   try {
//     const response = await fetch(endpoint, {
//       method: "GET",
//       ...options,
//       headers: {
//         "Accept-Language": locale,
//         "Content-Type": "application/json",
//         ...(token && { Authorization: `Bearer ${token}` }),
//         ...options.headers,
//       },
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.error || `Failed to fetch ${endpoint}`);
//     }

//     return await response.json();
//   } catch (error) {
//     // Safe error logging without circular references
//     console.log(
//       `Error fetching ${endpoint}:`,
//       error instanceof Error ? error.message : String(error)
//     );

//     // Create a new error without circular references
//     const safeError = new Error(
//       error instanceof Error ? error.message : `Failed to fetch ${endpoint}`
//     );
//     throw safeError;
//   }
// };
// const post = async <T>(
//   endpoint: string,
//   body: any,
//   options: ApiOptions = {},
//   isFormData: boolean = false
// ): Promise<T> => {
//   const locale = getLocaleFromUrl();
//   const token = getCookie("token");

//   const headers: Record<string, string> = {
//     "Accept-Language": locale,
//     ...(!isFormData && { "Content-Type": "application/json" }),
//     ...(token && { Authorization: `Bearer ${token}` }),
//     ...options.headers,
//   };

//   const response = await fetch(endpoint, {
//     method: "POST",
//     ...options,
//     headers,
//     body: isFormData ? body : JSON.stringify(body),
//   });

//   const data = await response.json();
  
//   if (!response.ok) {
//     return Promise.reject(data);
//   }

//   return data;
// };

export const fetchCountries = async (): Promise<Country[]> => {
  return get<Country[]>(`/api/countries`);
};

// export const fetchProfileInfo = async (): Promise<User> => {
//   return get<User>(`/api/profile`);
// };

export const fetchCities = async (id: number): Promise<City[]> => {
  return get<City[]>(`/api/cities/${id}`);
};

// export const updateProfile = async (profileData: any): Promise<User> => {
//   const formData = new FormData();

//   formData.append("first_name", profileData.first_name);
//   formData.append("last_name", profileData.last_name);
//   formData.append("phone", profileData.phone);
//   formData.append("email", profileData.email);

//   if (profileData.country_id) {
//     formData.append("country_id", String(profileData.country_id));
//   }
//   if (profileData.city_id) {
//     formData.append("city_id", String(profileData.city_id));
//   }

//   // Safe way to handle files - duck typing instead of instanceof
//   if (profileData.profile_image) {
//     const img = profileData.profile_image;
//     if (img && typeof img === "object" && "name" in img && "type" in img) {
//       formData.append("profile_image", img);
//     } else if (typeof img === "string") {
//       formData.append("profile_image_url", img);
//     }
//   }

//   if (profileData.cv) {
//     const cv = profileData.cv;
//     if (cv && typeof cv === "object" && "name" in cv && "type" in cv) {
//       formData.append("cv", cv);
//     }
//   }

//   return post<User>("/api/profile", formData, {}, true);
// };

// export const login = async (login: string, password: string): Promise<any> => {
//   const response = await post<any>("/api/login", { login, password });

//   setCookie("token", response.access_token, {
//     maxAge: 30 * 24 * 60 * 60,
//     path: "/",
//     secure: process.env.NODE_ENV === "production",
//     sameSite: "strict",
//   });

//   return response;
// };

// export const logout = async (): Promise<void> => {
//   const token = getCookie("token");

//   try {
//     await post<void>(
//       "/api/logout",
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//   } catch (error) {
//     console.log("Error during logout:", error);
//   } finally {
//     // حذف الكوكيز دائمًا حتى لو فشل طلب الخروج من الخادم
//     deleteCookie("token");
//     deleteCookie("authData");

//     window.dispatchEvent(new Event("authChange"));
//   }
// };

// export const register = async (formData: FormData): Promise<any> => {
//   try {
//     const response = await post<any>("/api/register", formData, {}, true);
    
//     if (response.access_token) {
//       setCookie("token", response.access_token, {
//         maxAge: 30 * 24 * 60 * 60,
//         path: "/",
//         secure: process.env.NODE_ENV === "production",
//         sameSite: "strict",
//       });
//       return response;
//     }
    
//     // If no access_token but response exists, throw it as error
//     throw response;
//   } catch (error: any) {
//     console.log("Registration error in client-action:", error);
//     throw error;
//   }
// };

export const forgetPassword = async (email: string): Promise<any> => {
  const response = await post<any>("/api/forgotPassword", { email });
  return response;
};

export const verifyResetToken = async (
  email: string,
  token: string
): Promise<any> => {
  const response = await post<any>("/api/verify-reset-code", { email, token });
  return response;
};

export const resetPassword = async (
  email: string,
  token: string,
  password: string,
  password_confirmation: string
): Promise<any> => {
  const response = await post<any>("/api/reset-password", {
    email,
    token,
    password,
    password_confirmation,
  });
  return response;
};

export const fetchApplicationDetails = async (
  id: number
): Promise<Application> => {
  const response = get<Application>(`/api/applications/${id}`);
  return response;
};

export const fetchJobTest = async (
  id: number,
  testId: number
): Promise<JobTest> => {
  return get<JobTest>(`/api/jobs/${id}/tests/${testId}`);
};

export const submitTestAnswers = async (
  jobId: number,
  testId: number,
  answers: { answers: Record<string, any> }
): Promise<any> => {
  try {
    const endpoint = `/api/jobs/${jobId}/tests/${testId}/submit`;
    console.log("🌐 Calling API endpoint:", endpoint);
    
    const response = await post<any>(endpoint, answers);
    
    console.log("✅ API response received:", response);
    console.log("📊 Response data:", JSON.stringify(response, null, 2));
    
    return response;
  } catch (error: any) {
    console.log("❌ API error:", error);
    console.log("Error object:", error);
    
    if (error.response) {
      console.log("Error response:", error.response);
      console.log("Error data:", error.response.data);
      console.log("Error status:", error.response.status);
    }
    
    throw error;
  }
};

// export const applyForJob = async (id: number): Promise<void> => {
//   return post<void>(`/api/jobs/${id}/apply`, {});
// };

export const fetchJobFilters = async (): Promise<FilterOptions> => {
  return get<FilterOptions>(`/api/filter-options`);
};

// export const fetchJobDetails = async (id: number): Promise<Job> => {
//   return get<Job>(`/api/jobs/${id}`);
// };

export const fetchFeaturedJobs = async (): Promise<FeaturedJobs> => {
  return get<FeaturedJobs>(`/api/featured-jobs `);
};

// export const fetchJobs = async (params: {
//   page: number;
//   search?: string;
//   work_sectors?: number[];
//   contract_types?: number[];
//   work_modes?: number[];
//   experience_levels?: number[];
//   education_levels?: number[];
//   countries?: number[];
//   salary_min?: number;
//   salary_max?: number;
// }): Promise<PaginatedResponse<Job>> => {
//   const queryParams = new URLSearchParams();
//   queryParams.append("page", params.page.toString());

//   if (params.search) {
//     queryParams.append("search", params.search);
//   }

//   if (params.work_sectors && params.work_sectors.length > 0) {
//     queryParams.append("work_sectors", params.work_sectors.join(","));
//   }

//   if (params.contract_types && params.contract_types.length > 0) {
//     queryParams.append("contract_types", params.contract_types.join(","));
//   }

//   if (params.work_modes && params.work_modes.length > 0) {
//     queryParams.append("work_modes", params.work_modes.join(","));
//   }

//   if (params.experience_levels && params.experience_levels.length > 0) {
//     queryParams.append("experience_levels", params.experience_levels.join(","));
//   }

//   if (params.education_levels && params.education_levels.length > 0) {
//     queryParams.append("education_levels", params.education_levels.join(","));
//   }

//   if (params.countries && params.countries.length > 0) {
//     queryParams.append("countries", params.countries.join(","));
//   }

//   if (params.salary_min !== undefined) {
//     queryParams.append("salary_min", params.salary_min.toString());
//   }

//   if (params.salary_max !== undefined) {
//     queryParams.append("salary_max", params.salary_max.toString());
//   }

//   const response = get<PaginatedResponse<Job>>(
//     `/api/jobs?${queryParams.toString()}`
//   );
//   return response;
// };

// export const fetchServices = async (): Promise<Service[]> => {
//   return get<Service[]>(`/api/services`);
// };

// export const fetchSubServices = async (): Promise<ServicesResponse> => {
//   const response = await get<ServicesResponse>(`/api/services/sub-services`);
//   console.log(response);
//   return response;
// };

// export const fetchSubService = async (id: number): Promise<SubService> => {
//   return get<SubService>(`/api/services/subService/${id}`);
// };

export const fetchSubServiceQuestions = async (
  id: number
): Promise<QuestionResponse> => {
  return get<QuestionResponse>(`/api/services/subService/${id}/questions`);
};

// export const requestService = async (
//   requestData: ServiceRequestData
// ): Promise<any> => {
//   try {
//     const endpoint = "/api/services/service-requests";

//     const response = await post<any>(endpoint, requestData);
//     return response;
//   } catch (error: any) {
//     console.log("Service request failed:", error);

//     if (error.response) {
//       console.log("Status:", error.response.status);
//       console.log("Headers:", error.response.headers);
//       console.log("Response data:", error.response.data);

//       if (error.response.data?.errors) {
//         console.log("Validation errors:", error.response.data.errors);
//       } else if (error.response.data?.message) {
//         console.log("Error message:", error.response.data.message);
//       }
//       if (error.response) {
//         console.log(
//           "Backend validation errors:",
//           JSON.stringify(error.response.data, null, 2)
//         );
//         console.log("Backend status:", error.response.status);
//         console.log("Backend headers:", error.response.headers);
//       }
//     } else if (error.request) {
//       console.log("No response received:", error.request);
//     } else {
//       console.log("Error setting up request:", error.message);
//     }

//     throw error;
//   }
// };

// export const fetchContactInfo = async (): Promise<Contact> => {
//   return get<Contact>(`/api/contact`);
// };
// export const fetchOrganization = async (): Promise<Organization> => {
//   return get<Organization>(`/api/organization`);
// };

// export const contactUs = async (
//   first_name: string,
//   last_name: string,
//   email: string,
//   phone: string,
//   subject: string,
//   notes: string
// ): Promise<any> => {
//   const response = await post<any>("/api/contact", {
//     first_name,
//     last_name,
//     email,
//     phone,
//     subject,
//     notes,
//   });
//   return response;
// };

// export const subscribe = async (email: string): Promise<any> => {
//   const response = await post<any>("/api/subscribe", {
//     email,
//   });
//   return response;
// };

/* ================== TYPES ================== */

interface ApiOptions extends RequestInit {
  headers?: Record<string, string>;
}

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

/* ================== CONFIG ================== */

const API_BASE = ""; // نفس الدومين (Next API proxy)

/* ================== HELPERS ================== */

const buildHeaders = (options?: ApiOptions) => {
  const locale = getLocaleFromUrl();
  const token = getCookie("token");

  return {
    "Accept-Language": locale,
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options?.headers,
  };
};

const handleError = async (response: Response, endpoint: string) => {
  let message = `Failed to fetch ${endpoint}`;
  try {
    const data = await response.json();
    message = data?.error || data?.message || message;
  } catch {
    // ignore JSON parse errors
  }
  throw new Error(message);
};

/* ================== CORE ================== */

const get = async <T>(endpoint: string, options: ApiOptions = {}): Promise<T> => {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    method: "GET",
    ...options,
    headers: buildHeaders(options),
  });

  if (!response.ok) {
    await handleError(response, endpoint);
  }

  return response.json();
};

const post = async <T>(
  endpoint: string,
  body: any,
  options: ApiOptions = {},
  isFormData = false
): Promise<T> => {
  const response = await fetch(`${API_BASE}${endpoint}`, {
    method: "POST",
    ...options,
    headers: {
      ...buildHeaders(options),
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    },
    body: isFormData ? body : JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};

/* ================== AUTH ================== */

export const login = async (login: string, password: string) => {
  const response = await post<any>("/api/login", { login, password });

  setCookie("token", response.access_token, {
    maxAge: 30 * 24 * 60 * 60,
    path: "/",
    secure: process.env.NODE_ENV === "production",
    sameSite: "strict",
  });

  return response;
};

export const logout = async () => {
  const token = getCookie("token");

  try {
    await post("/api/logout", {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } finally {
    deleteCookie("token");
    deleteCookie("authData");
    window.dispatchEvent(new Event("authChange"));
  }
};

export const register = async (formData: FormData) => {
  const response = await fetch("/api/register", {
    method: "POST",
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  if (data?.access_token) {
    setCookie("token", data.access_token, {
      maxAge: 30 * 24 * 60 * 60,
      path: "/",
      secure: process.env.NODE_ENV === "production",
      sameSite: "strict",
    });
  }

  return data;
};

/* ================== PROFILE ================== */

export const fetchProfileInfo = (): Promise<User> =>
  get<User>("/api/profile");

export const updateProfile = async (profileData: any): Promise<User> => {
  const formData = new FormData();

  Object.entries(profileData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value as any);
    }
  });

  return post<User>("/api/profile", formData, {}, true);
};

export const changePassword = async (data: {
  current_password: string;
  new_password: string;
  new_password_confirmation: string;
}): Promise<void> => {
  return post<void>("/api/change-password", data);
};

/* ================== APPLICATIONS ================== */

export const fetchMyApplications = async (
  page: number = 1
): Promise<PaginatedResponse<Application[]>> => {
  const response = await get<PaginatedResponse<Application[]>>(
    `/api/my-applications?page=${page}`
  );
  return response;
};

/* ================== EXAMS ================== */

export const fetchMyExams = async (
  page: number = 1
): Promise<PaginatedResponse<MyExamItem[]>> => {
  const response = await get<PaginatedResponse<MyExamItem[]>>(
    `/api/my-exams?page=${page}`
  );
  return response;
};

/* ================== CONVERSATIONS ================== */

export const fetchConversations = async (): Promise<any> => {
  return get<any>(`/api/messages?with_id=1`);
};

/* ================== JOBS ================== */

export const fetchJobs = (params: any): Promise<PaginatedResponse<Job>> => {
  const query = new URLSearchParams(params).toString();
  return get(`/api/jobs?${query}`);
};

export const fetchJobDetails = (id: number): Promise<Job> =>
  get(`/api/jobs/${id}`);

export const applyForJob = (id: number): Promise<void> =>
  post(`/api/jobs/${id}/apply`, {});

/* ================== SERVICES ================== */

export const fetchServices = (): Promise<Service[]> =>
  get<Service[]>("/api/services");

export const fetchSubServices = (): Promise<ServicesResponse> =>
  get("/api/services/sub-services");

export const fetchSubService = (id: number): Promise<SubService> =>
  get(`/api/services/subService/${id}`);

export const requestService = (data: ServiceRequestData) =>
  post("/api/services/service-requests", data);

/* ================== ORGANIZATION ================== */

export const fetchOrganization = (): Promise<Organization> =>
  get("/api/organization");

export const fetchContactInfo = (): Promise<Contact> =>
  get("/api/contact");

/* ================== MISC ================== */

export const subscribe = (email: string) =>
  post("/api/subscribe", { email });

export const contactUs = (payload: any) =>
  post("/api/contact", payload);
